import ApiRequest from '../request'

export default class FileWithContext {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async getCount(params) {
    try {
      const res = await this.apiRequest.get(`file_with_context/count`, params)
      return res
    } catch (error) {
      return error.response
    }
  }

  async checkDuplicate(fileName) {
    try {
      const res = await this.apiRequest.get(`file_with_context`, {
        filter: JSON.stringify({ purpose: fileName }),
        range: JSON.stringify([0, 0]),
      })
      return res
    } catch (error) {
      return error.response
    }
  }
}
